import React from 'react';
import PropTypes from 'prop-types';

import SEO from '../components/Core/SEO';
import Redirect from '../components/Core/Redirect';

/* Import an entire module for side effects only, without importing anything. This runs the module's global
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import#import_a_module_for_its_side_effects_only
 * import '../../static/sw';
 */

// TODO: look into serving the proper page via
// nginx instead of loading the index page and
// then redirecting afterwards, as this makes our
// page look like it has an empty body to Google

function IndexPage({ location }) {
  return (
    <>
      <SEO title="Free Math Learning Game for Kids | Prodigy Math Game" />
      <Redirect
        origin={location}
        location={location.pathname}
        getLangPreference
      />
    </>
  );
}

IndexPage.propTypes = {
  location: PropTypes.shape().isRequired,
};

export default IndexPage;
